import { ViewMode } from '@/constants/enum';
import TableChartIcon from '@/components/icons/tableChart';
import HistoricalTrendChartIcon from '@/components/icons/historicalTrendChart';
import BarChartHorizontalIcon from '@/components/icons/barChartHorizontal';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import React from 'react';
import BarChartOutlined from '@mui/icons-material/BarChartOutlined';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

interface ViewModeBarProps {
  viewModes: ViewMode[];
  currentViewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
}

const ViewModeBar: React.FC<ViewModeBarProps> = ({
  viewModes,
  currentViewMode,
  setViewMode,
}) => {
  const viewModeIcons = {
    [ViewMode.Table]: (
      <TableChartIcon sx={{ color: (theme) => theme.palette.text.primary }} />
    ),
    [ViewMode.Chart]: (
      <BarChartHorizontalIcon
        sx={{ color: (theme) => theme.palette.text.primary }}
      />
    ),
    [ViewMode.Summary]: (
      <DonutLargeIcon sx={{ color: (theme) => theme.palette.text.primary }} />
    ),
    [ViewMode.Historical]: (
      <HistoricalTrendChartIcon
        sx={{ color: (theme) => theme.palette.text.primary }}
      />
    ),
    [ViewMode.Pie]: (
      <DonutLargeIcon sx={{ color: (theme) => theme.palette.text.primary }} />
    ),
    [ViewMode.Bar]: (
      <BarChartOutlined
        sx={{
          //   transform: "rotate(90deg)",
          color: (theme) => theme.palette.text.primary,
        }}
      />
    ),
  };

  const contentViewIcons = viewModes.map((mode) => ({
    mode,
    svg: viewModeIcons[mode],
  }));

  const handleAlignment = (
    _event: React.MouseEvent<HTMLElement>,
    newAlignment: ViewMode | null,
  ) => {
    if (newAlignment !== null) {
      setViewMode(newAlignment);
    }
  };

  return (
    <ToggleButtonGroup
      value={currentViewMode}
      exclusive
      onChange={handleAlignment}
      aria-label='text alignment'
      sx={{ display: 'flex', marginTop: 3 }}
    >
      {contentViewIcons.map(({ svg, mode }) => (
        <ToggleButton
          value={mode}
          aria-label={mode}
          key={mode}
        >
          {svg}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default ViewModeBar;
